import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LibSharedModule } from '@lib-shared/lib-shared.module';

import { FallbackComponent } from './fallback.component';

import {
  ConnectionServiceOptions,
  ConnectionServiceOptionsToken,
} from 'ngx-connection-service';

@NgModule({
  providers: [
    {
      provide: ConnectionServiceOptionsToken,
      useValue: <ConnectionServiceOptions>{
        enableHeartbeat: true,
        heartbeatUrl: 'assets/ping.json',
        requestMethod: 'get',
        heartbeatInterval: 10000,
      },
    },
  ],
  imports: [CommonModule, LibSharedModule, FallbackComponent],
})
export class FallbackModule {}
